module.exports = __webpack_public_path__ + "static/media/52.1ceed5b2.jpg";